import { mixins } from 'vue-class-component';
import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import AutocompletionLocationService from '@/fo/components/autocompletion-location/autocompletion-location.service';
import AlertMixin from '@/shared/alert/alert.mixin';
import Vue2Filters from 'vue2-filters';

@Component({
  mixins: [Vue2Filters.mixin],
})
export default class AutocompletionLocation extends mixins(AlertMixin) {
  @Prop()
  public searchedLocation;

  @Inject('autocompletionLocationService')
  private autocompletionLocationService: () => AutocompletionLocationService;

  public autocompletionResults = [];
  public autocompletionResultsIsOpen: boolean = false;
  public isFetching: boolean = false;

  public mounted() {
    if (this.searchedLocation.length !== 0) {
      this.autocompleteLocation();
    }
  }

  /**
   * Watch: trigger method when prop searchedLocation changes
   */
  @Watch('searchedLocation')
  searchedLocationChanged() {
    if (this.searchedLocation.length !== 0) {
      this.autocompletionResultsIsOpen = true;
      this.autocompleteLocation();
    } else {
      this.autocompletionResultsIsOpen = false;
    }
  }

  /**
   * Call to searchSessionsService to autocomplete location input based on letters entered by user
   */
  public autocompleteLocation(): void {
    this.isFetching = true;
    this.autocompletionLocationService()
      .retrieveLocations(this.searchedLocation)
      .then(
        res => {
          this.autocompletionResults = res.data.features;
          this.autocompletionResults.forEach(el => (el.properties.city = this.setCityWithoutDistrict(el.properties.city)));
          this.isFetching = false;
        },
        err => {
          this.isFetching = false;
        }
      );
  }

  /**
   * On click on a autocompletion result, emit this location to parent component
   * @param result location selected by user
   */
  public setLocationResult(result) {
    this.autocompletionResultsIsOpen = false;
    this.$emit('clickOnResult', {
      inputLocation: result.properties.city + ' (' + result.properties.postcode + ')',
      city: result.properties.city,
      postalCode: result.properties.postcode,
      latitude: result.geometry.coordinates[1],
      longitude: result.geometry.coordinates[0],
    });
  }

  /**
   * Delete "XXe Arrondissement" in city name for Lyon, Marseille et Paris
   */
  public setCityWithoutDistrict(cityName: string): string {
    let newCityName: string;
    if (
      (cityName.includes('Lyon') || cityName.includes('Marseille') || cityName.includes('Paris')) &&
      cityName.substr(0, cityName.indexOf(' ')).length > 1
    ) {
      newCityName = cityName.substr(0, cityName.indexOf(' '));
    } else {
      newCityName = cityName;
    }
    return newCityName;
  }
}
